import React from "react";
import classNames from "classnames";

interface NoContentProps {
  Icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  label: string;
  children?: React.ReactNode;
  className?: string;
}

const NoContent = ({ Icon, label, children, className }: NoContentProps) => {
  return (
    <div className={classNames(styles.container, className)}>
      <div className={styles.iconContainer}>
        <Icon className={styles.icon} />
      </div>
      <div className={styles.label}>{label}</div>
      {children ? <div>{children}</div> : null}
    </div>
  );
};

const styles = {
  container: classNames(
    "tw-flex tw-h-full tw-flex-grow tw-flex-col tw-items-center tw-justify-center tw-gap-2",
  ),
  iconContainer: classNames("tw-fill-neutral-400 tw-stroke-neutral-400"),
  icon: classNames("tw-h-8 tw-w-8"),
  label: classNames("tw-mb-12 tw-text-lg tw-font-light tw-text-neutral-400"),
};

export default NoContent;
